import React from 'react';
import classnames from 'classnames';
import LevelSide from './side';
import LevelItem from './item';
import styles from './level.module.scss';
import { BREAKPOINTS } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
interface IProps {
    className?: string;
    children: React.ReactNode;
    tablet?: boolean;
    breakpoint?: BREAKPOINTS;
    narrow?: boolean;
}

function Level(props: IProps) {
    const { className, children, tablet, narrow, breakpoint, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(styles['level'], className, {
                [styles[`is-${breakpoint}`]]: breakpoint,
                [styles['is-tablet']]: tablet,
                [styles['is-narrow']]: narrow,
            } as any)}
        >
            {children}
        </Element>
    );
}

Level.Side = LevelSide;
Level.Item = LevelItem;

export default Level;
